import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { INavigationContent, INavigationState } from '../../types/store';
import {
  ICreateUpdateNavigationResponse,
  IGetAllNavigationsResponse,
} from '../../types/api/response/navigationresponse';
import { ICreateUpdateNavigationRequest } from '../../types/api/request/navigationrequest.d';

const initialState: INavigationState = {
  content: [],
  page: {
    size: 0,
    number: 0,
    totalElements: 0,
    totalPages: 0,
  },
};

const navigationSlice = createSlice({
  name: 'navigationSlice',
  initialState,
  reducers: {
    setNavigationPages: (state, action: PayloadAction<IGetAllNavigationsResponse>) => {
      state.content = action.payload.content;
    },
    deleteNavigationPage: (state, action) => {
      const id = action.payload;
      const rootIndex = state.content.findIndex((x) => x.id === id);
      if (rootIndex > -1) {
        state.content.splice(rootIndex, 1);
        state.page.size--;
        state.page.totalElements--;
      } else {
        for (const nav of state.content) {
          const childIndex = nav.children?.findIndex((c) => c.id === id) ?? -1;
          if (childIndex > -1) {
            nav.children.splice(childIndex, 1);
            break;
          }
        }
      }
    },
    addNavigationPage: (state, action: PayloadAction<ICreateUpdateNavigationResponse>) => {
      const nav = action.payload;
      if (nav.parent_id == null) {
        state.content.push(nav);
      } else {
        const parent = state.content.find((x) => x.id === nav.parent_id);
        if (parent) {
          if (!parent.children) parent.children = [];
          parent.children.push(nav);
        }
      }
    },
    updateNavigationPage: (state, action: PayloadAction<ICreateUpdateNavigationResponse>) => {
      const updated = action.payload;
      const rootIndex = state.content.findIndex((x: INavigationContent) => x.id === updated.id);
      if (rootIndex > -1) {
        state.content[rootIndex] = updated;
      } else {
        for (const nav of state.content) {
          const childIndex = nav.children?.findIndex((c) => c.id === updated.id) ?? -1;
          if (childIndex > -1) {
            nav.children[childIndex] = updated;
            break;
          }
        }
      }
    },
  },
});

export const { setNavigationPages, deleteNavigationPage, addNavigationPage, updateNavigationPage } =
  navigationSlice.actions;

export default navigationSlice.reducer;
